import { useCallback } from 'react'
import { useSignal } from '@preact/signals-react'
import { getSubmit, formatDate } from '@ui-seeker/utils'

import { BACKEND_APIS } from '@constants'
import { batchListData } from 'Pages/Batch/Page/@signals'


export default function useBatchTableInfo() {
	const isLoading = useSignal(false)
	const dateFilter = useSignal(null)

	const setDateFilter = useCallback((value = [new Date(), new Date()]) => {
		dateFilter.value = value
		if (!!dateFilter.value) {
			setIsLoading(true)
			getSubmit(`${BACKEND_APIS.BATCH}/admin`, {
				startBookingDate: formatDate(value[0], { format: 'yyyyMMdd' }),
				endBookingDate: formatDate(value[1], { format: 'yyyyMMdd' }),
			}).then(data => {
				batchListData.value = data
				setIsLoading(false)
			}).catch(() => setIsLoading(false))
		}
	}, [])


	const setIsLoading = useCallback(value => {
		isLoading.value = value
	}, [])

	return {
		isLoading,
		setIsLoading,
		dateFilter,
		setDateFilter,
	}

}